import { FC, useState } from 'react';
import NoImageFound from '../assets/img/No_Image_found.png';

interface ImageModalProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
}

const ImageModalView: FC<ImageModalProps> = ({ isOpen, imageUrl, onClose }) => {
  const [imageError, setImageError] = useState(false);

  if (!isOpen) return null;

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Image Preview</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <img
              src={imageError || !imageUrl ? NoImageFound : imageUrl}
              alt="Invoice Preview"
              style={{ 
                maxWidth: "100%", 
                maxHeight: "70vh",
                objectFit: "contain"
              }}
              onError={handleImageError}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModalView;